// @ts-nocheck
import React from 'react';
import PropTypes from 'prop-types';
import SolyticsChip from './SolyticsChip';

/**
 * Applied-filter chip shown beside the Filters button. Same control on every
 * page: bordered primary chip with a clear action.
 *
 * @param {function} onDelete - Clears the applied filter
 * @param {string} [label='Filter Applied'] - Saved filter name, or "Filter Applied"
 * @param {string|number} [maxWidth] - Caps the chip width; the label truncates with an ellipsis
 * @returns {React.ReactElement}
 */
const SolyticsAppliedFilterChip = ({
  onDelete,
  label = 'Filter Applied',
  maxWidth,
}) => (
  <SolyticsChip
    label={label}
    title={label}
    variant="bordered"
    color="primary"
    onDelete={onDelete}
    size="medium"
    maxWidth={maxWidth}
  />
);

SolyticsAppliedFilterChip.propTypes = {
  onDelete: PropTypes.func.isRequired,
  label: PropTypes.string,
  maxWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default SolyticsAppliedFilterChip;
